import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, withModifiers, createVNode, unref, Fragment, withDirectives, mergeProps, vShow, createBlock, createCommentVNode, createTextVNode, withCtx, toDisplayString } from "vue";
import { CdrLink, CdrImg } from "@rei/cedar";
import BuyBoxShopperInsight from "../BuyBoxShopperInsights/BuyBoxShopperInsights.mjs";
import BuyBoxAddToCart from "../BuyBoxAddToCart/BuyBoxAddToCart.mjs";
import BuyBoxMembership from "../BuyBoxMembership/BuyBoxMembership.mjs";
import BuyBoxFulfillmentTiles from "../BuyBoxFulfillmentTiles/BuyBoxFulfillmentTiles.mjs";
import BuyBoxNotifyMe from "../BuyBoxNotifyMe/BuyBoxNotifyMe.mjs";
import BuyBoxPickupContext from "../BuyBoxPickupContext/BuyBoxPickupContext.mjs";
import BuyBoxSizeColor from "../BuyBoxSizeColor/BuyBoxSizeColor.mjs";
import BuyBoxShipUrgency from "../BuyBoxShipUrgency/BuyBoxShipUrgency.mjs";
import BuyBoxFavoriteButton from "../BuyBoxFavoriteButton/BuyBoxFavoriteButton.mjs";
/* empty css                                        */
import CobrandLimitedTimeOffer from "../CobrandLimitedTimeOffer/CobrandLimitedTimeOffer.mjs";
const _hoisted_1 = {
  class: "purchase-form__cta-row"
};
const _hoisted_2 = {
  key: 1,
  "data-ui": "purchase-form-cobrand-message",
  class: "purchase-form__cobrand",
  "data-test": "purchase-form-cobrand"
};
const _hoisted_3 = {
  key: 0,
  class: "purchase-form__cobrand-2x"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxPurchaseForm",
  props: {
    addToCartButtonProps: {},
    cobrandLimitedTimeOfferDate: {
      default: "Oct 27"
    },
    colorSelectorProps: {},
    errors: {},
    favoriteButtonProps: {
      default: null
    },
    freeShipping: {},
    fulfillmentTileProps: {},
    isLowInventory: {
      type: Boolean,
      default: false
    },
    membershipMessaging: {},
    notifyMeProps: {},
    quantity: {},
    shipUrgency: {
      default: null
    },
    showNotifyMe: {
      type: Boolean
    },
    shopperInsightsProps: {
      default: null
    },
    sizeChart: {
      default: null
    },
    showShipUrgencyMessage: {
      type: Boolean,
      default: false
    },
    showShipUrgencyLink: {
      type: Boolean,
      default: false
    },
    sizeSelectorProps: {},
    skuSelectorProps: {},
    showCobrand: {
      type: Boolean,
      default: false
    },
    showCobrandDoubleRewards: {
      type: Boolean,
      default: false
    },
    showCobrandLimitedTimeOffer: {
      type: Boolean,
      default: false
    },
    contextualizedEarnMessage: {
      default: ""
    },
    cobrandMessage: {},
    pickupContextMessage: {},
    selectedPriceClearanceMessage: {
      default: ""
    }
  },
  emits: ["addToCart", "addToWishlist", "carouselHover", "colorHover", "colorUpdate", "dividendClick", "emailUpdate", "includeMembership", "memberInfoClick", "metricsClick", "notifyMe", "oversizeInfoClick", "qtyUpdate", "registerRef", "shippingInfoClick", "shipUpdate", "sizeClick", "sizeChartClick", "sizeHover", "sizeUpdate", "skuSelectUpdate", "storeFinderClick", "updateAddress", "updateEditorOpen", "updateGeolocation", "clearGeolocationError", "preorderBannerClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const hasShipUrgencyMessage = computed(() => props.shipUrgency && props.shipUrgency.message);
    const mastercardLink = computed(() => {
      const trackingId = props.showCobrandDoubleRewards ? "dre_pdp_2023" : "pdp_test_kl";
      return `/membership/mastercard?trackingId=${trackingId}`;
    });
    const handlePreApprovalCobrandLearnMore = (event) => {
      emit("metricsClick", {
        event,
        link: props.cobrandMessage.link,
        linkName: "rei co-op mastercard_See if you’re pre-approved"
      });
    };
    const handleCobrandLearnMore = () => {
      emit("metricsClick", {
        link: mastercardLink,
        linkName: "double reward_learn more"
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [createElementVNode("form", {
        onSubmit: withModifiers(() => {
        }, ["prevent"])
      }, [createVNode(unref(BuyBoxSizeColor), {
        "color-selector-props": _ctx.colorSelectorProps,
        errors: _ctx.errors,
        "is-low-inventory": _ctx.isLowInventory,
        quantity: _ctx.quantity,
        "size-chart": _ctx.sizeChart,
        "size-selector-props": _ctx.sizeSelectorProps,
        "sku-selector-props": _ctx.skuSelectorProps,
        "selected-price-clearance-message": _ctx.selectedPriceClearanceMessage,
        onCarouselHover: _cache[0] || (_cache[0] = (data) => _ctx.$emit("carouselHover", data)),
        onColorHover: _cache[1] || (_cache[1] = (data) => _ctx.$emit("colorHover", data)),
        onColorUpdate: _cache[2] || (_cache[2] = (data) => _ctx.$emit("colorUpdate", data)),
        onMetricsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("metricsClick", data)),
        onQtyUpdate: _cache[4] || (_cache[4] = (data) => _ctx.$emit("qtyUpdate", data)),
        onRegisterRef: _cache[5] || (_cache[5] = (ref) => _ctx.$emit("registerRef", ref)),
        onSizeClick: _cache[6] || (_cache[6] = (data) => _ctx.$emit("sizeClick", data)),
        onSizeHover: _cache[7] || (_cache[7] = (data) => _ctx.$emit("sizeHover", data)),
        onSizeUpdate: _cache[8] || (_cache[8] = (data) => _ctx.$emit("sizeUpdate", data)),
        onSkuSelectUpdate: _cache[9] || (_cache[9] = (data) => _ctx.$emit("skuSelectUpdate", data)),
        onSizeChartClick: _cache[10] || (_cache[10] = (data) => _ctx.$emit("sizeChartClick", data))
      }, null, 8, ["color-selector-props", "errors", "is-low-inventory", "quantity", "size-chart", "size-selector-props", "sku-selector-props", "selected-price-clearance-message"]), !_ctx.showNotifyMe ? (openBlock(), createElementBlock(Fragment, {
        key: 0
      }, [withDirectives(createVNode(unref(BuyBoxShipUrgency), mergeProps({
        class: "purchase-form__ship-urgency"
      }, _ctx.shipUrgency, {
        "show-ship-urgency-link": _ctx.showShipUrgencyLink
      }), null, 16, ["show-ship-urgency-link"]), [[vShow, _ctx.showShipUrgencyMessage && hasShipUrgencyMessage.value]]), createVNode(unref(BuyBoxFulfillmentTiles), mergeProps({
        class: ["purchase-form__fulfillment-tiles"]
      }, _ctx.fulfillmentTileProps, {
        onMetricsClick: _cache[11] || (_cache[11] = (data) => _ctx.$emit("metricsClick", data)),
        onRegisterRef: _cache[12] || (_cache[12] = (ref) => _ctx.$emit("registerRef", ref)),
        onStoreFinderClick: _cache[13] || (_cache[13] = ($event) => _ctx.$emit("storeFinderClick")),
        onShipUpdate: _cache[14] || (_cache[14] = (method) => _ctx.$emit("shipUpdate", method)),
        onUpdateAddress: _cache[15] || (_cache[15] = (data) => _ctx.$emit("updateAddress", data)),
        onUpdateGeolocation: _cache[16] || (_cache[16] = (data) => _ctx.$emit("updateGeolocation", data)),
        onUpdateEditorOpen: _cache[17] || (_cache[17] = (data) => _ctx.$emit("updateEditorOpen", data)),
        onClearGeolocationError: _cache[18] || (_cache[18] = ($event) => _ctx.$emit("clearGeolocationError")),
        onShippingInfoClick: _cache[19] || (_cache[19] = (data) => _ctx.$emit("shippingInfoClick", data)),
        onOversizeInfoClick: _cache[20] || (_cache[20] = (data) => _ctx.$emit("oversizeInfoClick", data)),
        onPreorderBannerClick: _cache[21] || (_cache[21] = (data) => _ctx.$emit("preorderBannerClick", data))
      }), null, 16), _ctx.pickupContextMessage.message ? (openBlock(), createBlock(unref(BuyBoxPickupContext), mergeProps({
        key: 0
      }, _ctx.pickupContextMessage, {
        class: "purchase-form__pickup-context",
        onStoreFinderClick: _cache[22] || (_cache[22] = (data) => _ctx.$emit("storeFinderClick", data))
      }), null, 16)) : createCommentVNode("", true), _ctx.membershipMessaging.showMembershipSection ? (openBlock(), createBlock(unref(BuyBoxMembership), mergeProps({
        key: 1,
        class: "purchase-form__membership"
      }, _ctx.membershipMessaging, {
        onMemberInfoClick: _cache[23] || (_cache[23] = ($event) => _ctx.$emit("memberInfoClick")),
        onMetricsClick: _cache[24] || (_cache[24] = (data) => _ctx.$emit("metricsClick", data)),
        onDividendClick: _cache[25] || (_cache[25] = ($event) => _ctx.$emit("dividendClick")),
        onIncludeMembership: _cache[26] || (_cache[26] = (data) => _ctx.$emit("includeMembership", data)),
        onRegisterRef: _cache[27] || (_cache[27] = (ref) => _ctx.$emit("registerRef", ref))
      }), null, 16)) : createCommentVNode("", true), _ctx.shopperInsightsProps ? (openBlock(), createBlock(unref(BuyBoxShopperInsight), mergeProps({
        key: 2,
        id: "shopper-insight",
        class: "purchase-form__shopper-insight"
      }, _ctx.shopperInsightsProps), null, 16)) : createCommentVNode("", true), createElementVNode("div", _hoisted_1, [createVNode(unref(BuyBoxAddToCart), mergeProps({
        id: "add-to-cart-button",
        class: "purchase-form__add-to-cart-button"
      }, _ctx.addToCartButtonProps, {
        onAddToCart: _cache[28] || (_cache[28] = ($event) => _ctx.$emit("addToCart"))
      }), null, 16), createVNode(unref(BuyBoxFavoriteButton), mergeProps(_ctx.favoriteButtonProps, {
        class: "purchase-form__favorite-button",
        onClick: _cache[29] || (_cache[29] = withModifiers(($event) => _ctx.$emit("addToWishlist"), ["prevent"]))
      }), null, 16)])], 64)) : createCommentVNode("", true)], 32), _ctx.showNotifyMe ? (openBlock(), createBlock(unref(BuyBoxNotifyMe), mergeProps({
        key: 0,
        class: "purchase-form__notify-me"
      }, _ctx.notifyMeProps, {
        onRegisterRef: _cache[30] || (_cache[30] = (ref) => _ctx.$emit("registerRef", ref)),
        onEmailUpdate: _cache[31] || (_cache[31] = (data) => _ctx.$emit("emailUpdate", data)),
        onNotifyMe: _cache[32] || (_cache[32] = (data) => _ctx.$emit("notifyMe", data)),
        onMetricsClick: _cache[33] || (_cache[33] = (data) => _ctx.$emit("metricsClick", data)),
        onAddToWishlist: _cache[34] || (_cache[34] = (data) => _ctx.$emit("addToWishlist", data))
      }), null, 16)) : createCommentVNode("", true), !_ctx.showNotifyMe && (_ctx.showCobrandDoubleRewards || _ctx.showCobrand) ? (openBlock(), createElementBlock("div", _hoisted_2, [_ctx.showCobrandDoubleRewards ? (openBlock(), createElementBlock("div", _hoisted_3, [_cache[43] || (_cache[43] = createElementVNode("div", {
        class: "purchase-form__cobrand-2x-heading"
      }, [createElementVNode("div", {
        class: "purchase-form__cobrand-2x-heading__badge"
      }, [createElementVNode("strong", null, "2X"), createElementVNode("span", null, [createTextVNode("REI CO-OP"), createElementVNode("sup", null, "®")]), createElementVNode("span", null, [createTextVNode("MASTERCARD"), createElementVNode("sup", null, "®")]), createElementVNode("span", null, "REWARDS")]), createTextVNode(" EARN DOUBLE CARD REWARDS ")], -1)), createElementVNode("p", null, [_cache[38] || (_cache[38] = createTextVNode(" With the REI Co-op")), _cache[39] || (_cache[39] = createElementVNode("sup", null, "®", -1)), _cache[40] || (_cache[40] = createTextVNode(" Mastercard")), _cache[41] || (_cache[41] = createElementVNode("sup", null, "®", -1)), _cache[42] || (_cache[42] = createTextVNode(", cardmembers earn 10% in card rewards on all your purchases at REI from 9/12 to 9/22. That’s 2x the usual! Terms apply. ")), createVNode(unref(CdrLink), {
        href: mastercardLink.value,
        onClick: handleCobrandLearnMore
      }, {
        default: withCtx(() => _cache[37] || (_cache[37] = [createTextVNode(" Learn more ")])),
        _: 1,
        __: [37]
      }, 8, ["href"])])])) : _ctx.showCobrandLimitedTimeOffer ? (openBlock(), createBlock(CobrandLimitedTimeOffer, {
        key: 1,
        "cobrand-limited-time-offer-date": _ctx.cobrandLimitedTimeOfferDate,
        onMetricsClick: _cache[35] || (_cache[35] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["cobrand-limited-time-offer-date"])) : (openBlock(), createElementBlock(Fragment, {
        key: 2
      }, [createVNode(unref(CdrImg), {
        class: "purchase-form__cobrand-img",
        src: "https://satchel.rei.com/media/product/cobrand.png",
        srcset: "https://satchel.rei.com/media/product/cobrand-2x.png 2x",
        alt: ""
      }), createElementVNode("p", null, [createElementVNode("span", {
        innerHTML: _ctx.cobrandMessage.initialText
      }, null, 8, _hoisted_4), createVNode(unref(CdrLink), {
        "data-ui": "cobrand-mastercard-link",
        href: _ctx.cobrandMessage.link,
        onClick: _cache[36] || (_cache[36] = ($event) => handlePreApprovalCobrandLearnMore($event))
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.cobrandMessage.ctaText), 1)]),
        _: 1
      }, 8, ["href"]), createElementVNode("span", {
        innerHTML: _ctx.cobrandMessage.finalText
      }, null, 8, _hoisted_5)])], 64))])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxPurchaseForm2.mjs.map
